window.addEventListener("gp:product-change-variant", (e) => {
    if(!e.detail.variantSelected) return;
    const variantId = e.detail.variantSelected.id;
    
    const pbxVariantChangeEvent = new CustomEvent("pbx:variant:change", {
        detail: {
            variantId: variantId, 
        },
    });

    document.dispatchEvent(pbxVariantChangeEvent);
});